/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'skip-forward': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M6.2 33.3c-.2 0-.4 0-.6-.1-.3-.3-.6-.7-.6-1.2V2c0-.5.3-.9.7-1.1.4-.2.9-.2 1.3.1l19.5 13.6V2c0-.7.6-1.3 1.2-1.3S29 1.3 29 2v30c0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2V19.4L7 33c-.3.2-.5.3-.8.3zM7.5 4.4v25.2L25.6 17 7.5 4.4z"/>'
  }
})
